import React, { useEffect, useState } from 'react'
import { GameRow } from './weekStyles'
import { getShortDate } from '../../../../Utils/formatting/formatting'
import { TeamsCol } from './teamsCol'
import type { EventGQL } from '../../../../Api'
import { WeekBoxCon } from '../../../Schedule/components/weekBox/weekStyles'
import { ChampSeriesScoreSections } from './ChampSeriesScoreSections'
import { incompleteMarkets } from '../../../../Config/League/league.config'
import { NoDateCallout } from '../../../Schedule/components/weekBox/NoDateCallout'

type WeekBoxParams = {
  week: string
  events: EventGQL[]
}

export const WeekBox: React.FC<React.PropsWithChildren<WeekBoxParams>> = ({
  events,
  week,
}) => {
  const [isIncomplete, setIsIncomplete] = useState<boolean>(true)

  useEffect(() => {
    if (events.length > 0) {
      //Checking if market is complete or not
      let isIncomp = incompleteMarkets.includes(week)
      setIsIncomplete(isIncomp)
    }
  }, [events])

  const findFirstEvent = () => {
    let ev = events.find((e) => e.week === week)
    if (ev) {
      return ev
    } else {
      return events[0]
    }
  }

  if (events.length === 0) {
    return <div />
  }

  return (
    <>
      <WeekBoxCon>
        {events.length > 0 && events[0].seasonSegment === 'champseries' && (
          <ChampSeriesScoreSections events={events} />
        )}
        {events.length > 0 && isIncomplete && (
          <NoDateCallout event={findFirstEvent()} page="scores" />
        )}
        {events.length > 0 &&
          !isIncomplete &&
          events[0].seasonSegment !== 'champseries' &&
          events.map((event) => (
            <GameRow key={event.slugname}>
              <div className="gameCol">
                <p className="dateRow">{getShortDate(event.startTime)}</p>
                <TeamsCol event={event} />
              </div>
            </GameRow>
          ))}
      </WeekBoxCon>
    </>
  )
}
